<template>
  <el-table
    :data="pageData.outOrd.body['outOrdItem']"
    class="ik-list-table"
    height="250"
    :header-row-class-name="'ik-list-table-header-row'"
    :header-cell-class-name="'ik-list-table-header-cell'"
    :row-class-name="'ik-list-table-body-row'"
    :cell-class-name="'ik-list-table-body-cell'"
    :highlight-current-row="true"
    :stripe="true"
    :border="true"
  >
    <el-table-column prop="materielCode" label="药品编码" align="center" />
    <el-table-column prop="materielName" label="药品名称" align="center" />
    <el-table-column prop="supplierName" label="供应商" align="center" />
    <el-table-column prop="manufacturerName" label="生产商" align="center" />
    <el-table-column prop="batchCode" label="批次" align="center" />
    <el-table-column prop="number" label="数量" align="center" />
  </el-table>
</template>

<script>
export default {
  name: "OutList",
  inject: ["pageData"]
}
</script>

<style scoped lang="scss">

</style>
